export let ONE_DAY = 'one_day';
export const TWO_DAYS = 'two_days';
export const THREE_DAYS = 'three_days';
export const ONE_WEEK = 'one_week';
export const TWO_WEEKS = 'two_weeks';
